/** `/app/clients/new` — the identity step of the client wizard.
 *
 *  Replaces the `NewClient` dialog that `Clients.js` and `TopNav.js` used to open. Creating the
 *  trainee navigates (replace) to `/app/clients/:userId/setup`, so this route is only ever the
 *  "client does not exist yet" half of the flow. */

import { Box } from "@mui/material";
import { RTL } from "../cache/CacheRtl";
import ClientSetupWizard from "../componenets/client/setup/ClientSetupWizard";

/** Exactly one `<RTL>` per page: nested `CacheRtl` providers each own an emotion insertion
 *  point, which reproduces the `insertBefore` crash the wizard is careful to avoid. */
const NewClientPage = () => (
  <RTL>
    <Box dir="rtl">
      <ClientSetupWizard mode="create" />
    </Box>
  </RTL>
);

export default NewClientPage;
